import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs, Modal, Tooltip, OverlayTrigger} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { coberturasTratamento, papeisAssinatura } from '../../common/utils';
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import { FaArrowDown, FaArrowUp, FaCheck, FaTimes, FaStream, FaEye, FaQuestionCircle } from "react-icons/fa";
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

class TipoEquipamentoEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            nome: '',
            nomeHelper: '',
            erroLoadRegistro: "",
            tipo_equipamento_id: "",
            titulo_pagina: "",
            loading: false,
        };

    }

    componentDidMount(){
        const id = this.props.router.params.id;

        if(id){
            this.setState({
                tipo_equipamento_id: id,
                titulo_pagina: 'Editando Tipo de Equipamento',
                loading: true,
                erroLoadRegistro: ''
            })

            //consulta os dados do programa na api
            api.get(`/inventario/tipos/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    nome: dados.nome,
                    loading: false
                })
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar Tipo de Equipamento, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        else {
            this.setState({
                tipo_equipamento_id: '',
                titulo_pagina: 'Adicionar Tipo de Equipamento',
                loading: false,
                erroLoadRegistro: '',
            })
        }
    }

    enviaRegistro = (e) => {
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            nomeHelper: "",
            cidIdHelper: ""
        });

        //vererifica se é edição ou adição
        const url = (this.state.tipo_equipamento_id) ? '/inventario/tipos/'+this.state.tipo_equipamento_id+'/' : '/inventario/tipos/'
        const metodo = (this.state.tipo_equipamento_id) ? 'put' : 'post'

        formData.append('nome', this.state.nome);

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.tipo_equipamento_id) ? 'Tipo de Equipamento atualizado com sucesso' : 'Tipo de Equipamento cadastrado com sucesso';

            MySwal.fire({
                title: 'Sucesso!',
                html: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.tipo_equipamento_id){
                this.props.router.navigate("/tipo-equipamento");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o Tipo de Equipamento, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'nome'){
                        this.setState({ nomeHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    render(){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosTipoEquipamento" id="tabs-tipoEquipamento" className="aditus-tabs">
                    <Tab eventKey="dadosTipoEquipamento" title="Dados do Tipo de Equipamento">
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <Form onSubmit={this.enviaRegistro}>
                                    <h4>Dados do Tipo de Equipamento</h4>
                                    <Row>
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nome do Equipamento</Form.Label>
                                                <Form.Control type="text" name="nome" required placeholder="Nome do Equipamento" value={this.state.nome} onChange={this.handleChange} />    
                                                <Form.Text id="formNomeHelper" className="text-danger">{this.state.nomeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {this.state.erroLoadRegistro ? 
                                    <Alert variant="warning">
                                        {this.state.erroLoadRegistro}
                                    </Alert> : ''
                                    }                                      
                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar
                                            </>
                                        )}
                                    </Button>
                                </Form> 
                            </Card.Body>                
                        </Card>
                    </Tab>
                </Tabs>
            </div>
        )
    }
}

export default withRouter(TipoEquipamentoEdit);